(function(){
    angular
        .module('app')
        .directive('stringToNumber', StringToNumber);
        StringToNumber.$inject = ['$timeout'];
        function StringToNumber($timeout){
            return {
            require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                ngModel.$parsers.push(function(value) {
                    return '' + value;
                });
                ngModel.$formatters.push(function(value) {
                    return parseFloat(value);
                });
            }
          }
      }
})();